import React, { Suspense } from "react";
import "./App.css";

const Home = React.lazy(() => import("./home/Home"));
function App() {
  return (
    <div className="App">
      <Suspense fallback={<h1>Loading...</h1>}>
        <Home />
      </Suspense>
    </div>
  );
}

export default App;
